<template>
  <div class="container">
    <div v-if="data.fullWidthImage" class="my-10 lg:my-28">
      <div>
        <Image
          loading="lazy"
          class="rounded-3xl object-cover"
          :src="
            data?.fullWidthImage!.responsiveImage
              ? data?.fullWidthImage!.responsiveImage?.src
              : data?.fullWidthImage!.url
          "
          :srcset="
            data?.fullWidthImage!.responsiveImage
              ? data?.fullWidthImage!.responsiveImage?.webpSrcSet
              : undefined
          "
          :width="
            data?.fullWidthImage!.responsiveImage
              ? data?.fullWidthImage!.responsiveImage?.width
              : data?.fullWidthImage!.width
          "
          :height="
            data?.fullWidthImage!.responsiveImage
              ? data?.fullWidthImage!.responsiveImage?.height
              : data?.fullWidthImage!.height
          "
          :sizes="data.fullWidthImage?.responsiveImage?.sizes"
          :alt="data?.fullWidthImage!.alt!"
        />
      </div>
    </div>

    <div
      v-if="data.fullWidthVideo"
      class="relative my-10 aspect-video w-full overflow-hidden lg:my-28"
    >
      <VideoEmbed :data="data.fullWidthVideo" class="absolute left-0 top-0 h-full w-full" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { SectionMediafullRecord } from '~/types/generated'

defineProps({
  data: {
    type: Object as PropType<SectionMediafullRecord>,
    default: () => {}
  }
})
</script>
